import { Icon, Row, Text } from 'components';
import { theme } from 'lib';
import { useSelector } from 'react-redux';

const WinnerItem = ({ item, idx }) => {
  const { type, text, users, sport } = item,
    { isMobile } = useSelector((state) => state.appState);

  function getIcon() {
    switch (item.type) {
      case 'win':
        return 'throphy';

      case 'achievement':
        return sport === 'soccer' ? 'football' : sport;

      default:
        return 'sport';
    }
  }

  return (
    <Row
      wid={isMobile ? '276px' : '456px'}
      ht={isMobile ? '86px' : '68px'}
      bg={theme.SECONDARY}
      noFlex
      centerAll
      style={{ flexShrink: 0 }}
    >
      <Row wid="calc(100% - 32px)" ht="100%" center between pad={isMobile && '0 16px'}>
        <Row noFlex center ht="100%">
          <Icon type={getIcon()} dimensions={27} col="#fff" />

          <Text
            wordBreak="break-word"
            marg="0 14px 0 12px"
            maxWid="352px"
            b2
            med
            col="#fff"
            wid="100%"
          >
            {text}
          </Text>
        </Row>

        <Icon type="rightChevron" col="#fff" dimensions={12} />
      </Row>
    </Row>
  );
};

export default WinnerItem;
